export default "__VITE_ASSET__Q0WGNnjc__ 40w, __VITE_ASSET__9a2lJMYr__ 80w, __VITE_ASSET__oEIKGJd6__ 120w";